import { template } from "@ember/template-compiler";
import Component from '@glimmer/component';
import { LinkTo } from '@ember/routing';
import { STYLES } from './anchor.gts';
import type { VALID_VARIANTS } from './anchor';
import { default as IconComponent } from '../../-private/components/link-or-button-icon.gts';
import type { Signature as IconSignature } from '../../-private/components/link-or-button-icon';
export interface Signature {
    Element: HTMLAnchorElement;
    Args: {
        // See https://steveholgado.com/typescript-types-from-arrays to understand this type
        variant?: (typeof VALID_VARIANTS)[number];
        icon?: IconSignature['Args']['icon'];
        route?: string;
        models?: unknown[];
        model?: unknown;
        query?: Record<string, unknown>;
        ariaLabel?: string;
    };
    Blocks: {
        default: [];
    };
}
export default class WrLinkToComponent extends Component<Signature> {
    get variant() {
        return this.args.variant || 'link';
    }
    get styles() {
        return [
            ...STYLES.base,
            ...STYLES[this.variant]
        ].join(' ');
    }
    get query() {
        return this.args.query ?? {};
    }
    static{
        template(`
    {{#if @model}}
      <LinkTo
        @route={{@route}}
        @model={{@model}}
        @query={{this.query}}
        class={{this.styles}}
        aria-label={{@ariaLabel}}
        ...attributes
      >
        <IconComponent @icon={{@icon}} />
        {{yield}}
      </LinkTo>
    {{else if @models}}
      <LinkTo
        @route={{@route}}
        @models={{@models}}
        @query={{this.query}}
        class={{this.styles}}
        aria-label={{@ariaLabel}}
        ...attributes
      >
        <IconComponent @icon={{@icon}} />
        {{yield}}
      </LinkTo>
    {{else if @query}}
      <LinkTo
        @route={{@route}}
        @query={{this.query}}
        class={{this.styles}}
        aria-label={{@ariaLabel}}
        ...attributes
      >
        <IconComponent @icon={{@icon}} />
        {{yield}}
      </LinkTo>
    {{else if @route}}
      <LinkTo
        @route={{@route}}
        class={{this.styles}}
        aria-label={{@ariaLabel}}
        ...attributes
      >
        <IconComponent @icon={{@icon}} />
        {{yield}}
      </LinkTo>
    {{/if}}
  `, {
            component: this,
            eval () {
                return eval(arguments[0]);
            }
        });
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi9ob21lL3NlbWVpYS9wYWNrYWdlcy9lbWJlci1hZGRvbnMvdjIvZW1iZXItd2lzZXIvc3JjL2NvbXBvbmVudHMvd3IvbGluay10by5ndHMiXSwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IENvbXBvbmVudCBmcm9tICdAZ2xpbW1lci9jb21wb25lbnQnO1xuaW1wb3J0IHsgTGlua1RvIH0gZnJvbSAnQGVtYmVyL3JvdXRpbmcnO1xuaW1wb3J0IHsgU1RZTEVTIH0gZnJvbSAnLi9hbmNob3IuZ3RzJztcbmltcG9ydCB0eXBlIHsgVkFMSURfVkFSSUFOVFMgfSBmcm9tICcuL2FuY2hvcic7XG5pbXBvcnQgeyBkZWZhdWx0IGFzIEljb25Db21wb25lbnQgfSBmcm9tICcuLi8uLi8tcHJpdmF0ZS9jb21wb25lbnRzL2xpbmstb3ItYnV0dG9uLWljb24uZ3RzJztcbmltcG9ydCB0eXBlIHsgU2lnbmF0dXJlIGFzIEljb25TaWduYXR1cmUgfSBmcm9tICcuLi8uLi8tcHJpdmF0ZS9jb21wb25lbnRzL2xpbmstb3ItYnV0dG9uLWljb24nO1xuXG5leHBvcnQgaW50ZXJmYWNlIFNpZ25hdHVyZSB7XG4gIEVsZW1lbnQ6IEhUTUxBbmNob3JFbGVtZW50O1xuICBBcmdzOiB7XG4gICAgLy8gU2VlIGh0dHBzOi8vc3RldmVob2xnYWRvLmNvbS90eXBlc2NyaXB0LXR5cGVzLWZyb20tYXJyYXlzIHRvIHVuZGVyc3RhbmQgdGhpcyB0eXBlXG4gICAgdmFyaWFudD86ICh0eXBlb2YgVkFMSURfVkFSSUFOVFMpW251bWJlcl07XG4gICAgaWNvbj86IEljb25TaWduYXR1cmVbJ0FyZ3MnXVsnaWNvbiddO1xuICAgIHJvdXRlPzogc3RyaW5nO1xuICAgIG1vZGVscz86IHVua25vd25bXTtcbiAgICBtb2RlbD86IHVua25vd247XG4gICAgcXVlcnk_OiBSZWNvcmQ8c3RyaW5nLCB1bmtub3duPjtcbiAgICBhcmlhTGFiZWw_OiBzdHJpbmc7XG4gIH07XG4gIEJsb2Nrczoge1xuICAgIGRlZmF1bHQ6IFtdO1xuICB9O1xufVxuXG5leHBvcnQgZGVmYXVsdCBjbGFzcyBXckxpbmtUb0NvbXBvbmVudCBleHRlbmRzIENvbXBvbmVudDxTaWduYXR1cmU-IHtcbiAgZ2V0IHZhcmlhbnQoKSB7XG4gICAgcmV0dXJuIHRoaXMuYXJncy52YXJpYW50IHx8ICdsaW5rJztcbiAgfVxuXG4gIGdldCBzdHlsZXMoKSB7XG4gICAgcmV0dXJuIFsuLi5TVFlMRVMuYmFzZSwgLi4uU1RZTEVTW3RoaXMudmFyaWFudF1dLmpvaW4oJyAnKTtcbiAgfVxuXG4gIGdldCBxdWVyeSgpIHtcbiAgICByZXR1cm4gdGhpcy5hcmdzLnF1ZXJ5ID8_IHt9O1xuICB9XG5cbiAgPHRlbXBsYXRlPlxuICAgIHt7I2lmIEBtb2RlbH19XG4gICAgICA8TGlua1RvXG4gICAgICAgIEByb3V0ZT17e0Byb3V0ZX19XG4gICAgICAgIEBtb2RlbD17e0Btb2RlbH19XG4gICAgICAgIEBxdWVyeT17e3RoaXMucXVlcnl9fVxuICAgICAgICBjbGFzcz17e3RoaXMuc3R5bGVzfX1cbiAgICAgICAgYXJpYS1sYWJlbD17e0BhcmlhTGFiZWx9fVxuICAgICAgICAuLi5hdHRyaWJ1dGVzXG4gICAgICA-XG4gICAgICAgIDxJY29uQ29tcG9uZW50IEBpY29uPXt7QGljb259fSAvPlxuICAgICAgICB7e3lpZWxkfX1cbiAgICAgIDwvTGlua1RvPlxuICAgIHt7ZWxzZSBpZiBAbW9kZWxzfX1cbiAgICAgIDxMaW5rVG9cbiAgICAgICAgQHJvdXRlPXt7QHJvdXRlfX1cbiAgICAgICAgQG1vZGVscz17e0Btb2RlbHN9fVxuICAgICAgICBAcXVlcnk9e3t0aGlzLnF1ZXJ5fX1cbiAgICAgICAgY2xhc3M9e3t0aGlzLnN0eWxlc319XG4gICAgICAgIGFyaWEtbGFiZWw9e3tAYXJpYUxhYmVsfX1cbiAgICAgICAgLi4uYXR0cmlidXRlc1xuICAgICAgPlxuICAgICAgICA8SWNvbkNvbXBvbmVudCBAaWNvbj17e0BpY29ufX0gLz5cbiAgICAgICAge3t5aWVsZH19XG4gICAgICA8L0xpbmtUbz5cbiAgICB7e2Vsc2UgaWYgQHF1ZXJ5fX1cbiAgICAgIDxMaW5rVG9cbiAgICAgICAgQHJvdXRlPXt7QHJvdXRlfX1cbiAgICAgICAgQHF1ZXJ5PXt7dGhpcy5xdWVyeX19XG4gICAgICAgIGNsYXNzPXt7dGhpcy5zdHlsZXN9fVxuICAgICAgICBhcmlhLWxhYmVsPXt7QGFyaWFMYWJlbH19XG4gICAgICAgIC4uLmF0dHJpYnV0ZXNcbiAgICAgID5cbiAgICAgICAgPEljb25Db21wb25lbnQgQGljb249e3tAaWNvbn19IC8-XG4gICAgICAgIHt7eWllbGR9fVxuICAgICAgPC9MaW5rVG8-XG4gICAge3tlbHNlIGlmIEByb3V0ZX19XG4gICAgICA8TGlua1RvXG4gICAgICAgIEByb3V0ZT17e0Byb3V0ZX19XG4gICAgICAgIGNsYXNzPXt7dGhpcy5zdHlsZXN9fVxuICAgICAgICBhcmlhLWxhYmVsPXt7QGFyaWFMYWJlbH19XG4gICAgICAgIC4uLmF0dHJpYnV0ZXNcbiAgICAgID5cbiAgICAgICAgPEljb25Db21wb25lbnQgQGljb249e3tAaWNvbn19IC8-XG4gICAgICAgIHt7eWllbGR9fVxuICAgICAgPC9MaW5rVG8-XG4gICAge3svaWZ9fVxuICA8L3RlbXBsYXRlPlxufVxuIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQSxPQUFPLGVBQWUscUJBQXFCO0FBQzNDLFNBQVMsTUFBTSxRQUFRLGlCQUFpQjtBQUN4QyxTQUFTLE1BQU0sUUFBUSxlQUFlO0FBQ3RDLGNBQWMsY0FBYyxRQUFRLFdBQVc7QUFDL0MsU0FBUyxXQUFXLGFBQWEsUUFBUSxvREFBb0Q7QUFDN0YsY0FBYyxhQUFhLGFBQWEsUUFBUSxnREFBZ0Q7QUFFaEcsaUJBQWlCO0lBQ2YsU0FBUztJQUNUO1FBQ0Usb0ZBQW9GO1FBQ3BGLGtCQUFrQixnQkFBZ0IsTUFBTTtRQUN4QyxPQUFPLGNBQWMsUUFBUTtRQUM3QixRQUFRLE1BQU07UUFDZCxTQUFTLE9BQU87UUFDaEIsUUFBUSxPQUFPO1FBQ2YsUUFBUSxPQUFPLE1BQU0sRUFBRSxPQUFPO1FBQzlCLFlBQVksTUFBTTs7SUFFcEI7UUFDRTs7O0FBSUosZUFBZSxNQUFNLDBCQUEwQixVQUFVO0lBQ3ZELElBQUksVUFBVTtRQUNaLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxPQUFPLElBQUk7SUFDOUI7SUFFQSxJQUFJLFNBQVM7UUFDWCxPQUFPO2VBQUksT0FBTyxJQUFJO2VBQUssTUFBTSxDQUFDLElBQUksQ0FBQyxPQUFPLENBQUM7U0FBQyxDQUFDLElBQUksQ0FBQztJQUN4RDtJQUVBLElBQUksUUFBUTtRQUNWLE9BQU8sSUFBSSxDQUFDLElBQUksQ0FBQyxLQUFLLElBQUksQ0FBQztJQUM3QjtJQUVBLE1BQUE7UUFBQSxTQUFVLENBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0VBK0NWLENBQUEsRUFBQTtZQUFBLFdBQUEsSUFBVztZQUFYO2dCQUFBLE9BQUEsS0FBQSxTQUFBLENBQUEsRUFBVztZQUFEO1FBQUE7SUFBQSxDQS9DQTtBQWdEWiJ9